import {
  AddApplicationsToJobPostingDocument,
  AddApplicationsToJobPostingMutation,
  AddApplicationsToJobPostingMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useAddApplicationsToJobPosting = () => {
  const [addApplicationsToJobPostingMutation, { loading }] = useMutation(
    AddApplicationsToJobPostingDocument,
    {
      extractorFn: (data: AddApplicationsToJobPostingMutation) =>
        data.atsMutations.createFromApplicationsAtsApplication,
    }
  )

  return {
    loading,
    addApplicationsToJobPosting(variables: AddApplicationsToJobPostingMutationVariables) {
      return addApplicationsToJobPostingMutation({
        variables,
      })
    },
  }
}
